export default "__VITE_ASSET__vGF$Hhc1__"